import { NgModule, APP_INITIALIZER } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { DashboardSelectorComponent } from '../dashboard-selector/dashboard-selector.component';
import { DashboardService } from '../../../services/dashboard/dashboard.service';
import { firstValueFrom } from 'rxjs';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatDialogModule } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { MatTabsModule } from '@angular/material/tabs';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DunaDashboardComponent } from './duna-dashboard.component';
import { AddDashboardItemDialogComponent } from './add-dashboard-item-dialog/add-dashboard-item-dialog.component';
import { LocationSelectionDialogComponent } from './location-selection-dialog/location-selection-dialog.component';
import { EducationSelectionDialogComponent } from './education-selection-dialog/education-selection-dialog.component';
import { GroupSelectionDialogComponent } from './group-selection-dialog/group-selection-dialog.component';

// Factory function to initialize the dashboard
// Removed automatic resetToDefault call as it was blocking and preventing proper template loading
// Dashboard will be loaded when the component initializes via loadUserDashboardConfig
export function initializeDashboard(dashboardService: DashboardService) {
  return () => {
    // Don't call resetToDefault here - let the component load from backend template
    return Promise.resolve();
  };
}

@NgModule({
  declarations: [
  ],
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatSelectModule,
    MatButtonModule,
    MatIconModule,
    DashboardSelectorComponent,
    MatProgressSpinnerModule,
    MatDialogModule,
    MatInputModule,
    MatTabsModule,
    FormsModule,
    ReactiveFormsModule,
    DunaDashboardComponent,
    AddDashboardItemDialogComponent,
    LocationSelectionDialogComponent,
    EducationSelectionDialogComponent,
    GroupSelectionDialogComponent
  ],
  exports: [
    DashboardSelectorComponent,
    DunaDashboardComponent
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: initializeDashboard,
      deps: [DashboardService],
      multi: true
    }
  ]
})
export class DunaDashboardModule { } 